import { HorizontalDivider } from 'components/UI'

import {
	AllSmartContracts,
	ProjectDetailsSection,
	RecentWorkspaces,
	RightSidebar
} from './components'

const DAppDashboard = () => (
	<div class='m-auto mb-14 flex max-w-[1060px] flex-col overflow-y-auto px-8 py-8 xl:px-3 2xl:px-0'>
		<ProjectDetailsSection />

		<HorizontalDivider className='my-10' />

		<div class='grid grid-cols-3 gap-10'>
			<div class='order-2 col-span-3 lg:order-1 lg:col-span-2'>
				<RecentWorkspaces />
				<AllSmartContracts />
			</div>
			<div class='order-1 col-span-3 lg:order-2 lg:col-span-1'>
				<RightSidebar />
			</div>
		</div>
	</div>
)

export { DAppDashboard }
